import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { getUserProfilePictureThunk } from '../thunks/user-profile.thunk'

export type GetUserProfilePictureState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
}

export const initialState: GetUserProfilePictureState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
}

const getUserProfilePictureSlice = createSlice({
  name: 'getUserProfilePictureSlice',
  initialState: initialState,
  reducers: {
    resetUserProfilePictureState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserProfilePictureThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .addCase(getUserProfilePictureThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED

        // state.requestResponse.data = action.payload.description
      })
      .addCase(getUserProfilePictureThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetUserProfilePictureState } = getUserProfilePictureSlice.actions
export default getUserProfilePictureSlice.reducer
